import {all, fork} from 'redux-saga/effects';
import OrderGroupWatcher from './ListOrderGroup/sagaWatcher';

export default function* () {
    yield all([fork(OrderGroupWatcher)]);
}
